export function addDataUser(data) {
  return {
    type: 'ADD_DATA_USER',
    data,
  };
}
